// extracted by mini-css-extract-plugin
export var aircallIframe = "_fj-3";
export var fabContainer = "_fj-5";
export var fabRinging = "_fj-6";
export var loadingOverlay = "_fj-4";
export var pulse = "_fj-7";
export var widgetContent = "_fj-2";
export var widgetPanel = "_fj-0";
export var widgetPanelExpanded = "_fj-1";